import * as React from "react";
import { Card } from "azure-devops-ui/Card";
import { Header, TitleSize } from "azure-devops-ui/Header";
import { Page } from "azure-devops-ui/Page";

export default class HeaderExample extends React.Component<{}> {
    public render() {
        return (
            <Page>
                <Header
                    title={"Header title"}
                    titleSize={TitleSize.Medium}
                    backButtonProps={{ onClick: () => alert("Back button Clicked!!") }}
                    titleAriaLevel={3}
                />

                <div className="page-content page-content-top">
                    <Card>Page content</Card>
                </div>
            </Page>
        );
    }
}
